function IconDeviceMobile({ size = 24, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.1668 4.66667H15.5002M14.3335 19.8333V19.845M9.66683 3.5H19.0002C20.2888 3.5 21.3335 4.54467 21.3335 5.83333V22.1667C21.3335 23.4553 20.2888 24.5 19.0002 24.5H9.66683C8.37817 24.5 7.3335 23.4553 7.3335 22.1667V5.83333C7.3335 4.54467 8.37817 3.5 9.66683 3.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

IconDeviceMobile.displayName = 'IconDeviceMobile';

export { IconDeviceMobile };
